require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dart-uri-google-static-maps-api.json") })
        }
      }, "path---dart-uri-google-static-maps-api");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dart-uri-google-static-maps-api!./.cache/json/dart-uri-google-static-maps-api.json
// module id = 377
// module chunks = 231608221292675